export default __webpack_public_path__ + "static/media/Group 8706_6.a7293244.jpg";